import documentApiClient from '@/tsClient/servers/noodleDocuments';

const serverError = async (): Promise<void> => {
  await documentApiClient.get('/for-developers/test-errors/server-error');
};

export default serverError;
